import StorageManager from '../../../utils/storageManager'
import config from '../../../config'
import * as types from './mutation-types'
import * as globalTypes from '../../mutation-types'
import * as sr from "ms-signalr"
import mitelService from '../../../api/clients/mitelService'
import thirdPartyAPI from '../../../api/thirdparty.js'

export const connectToMitel = async ({ dispatch, commit, state, rootState }) => {
    var miccSdkBase = `${config.miccServerBase}/miccsdk`;
    var accessToken = StorageManager.getJWT("MitelServiceJWT");
    var employeeHub;

    var miccSignalr = $.hubConnection(miccSdkBase, {
        qs: `sessionid=Bearer ${accessToken}`
    });

    await miccSignalr.start().done(function () {
        console.info(`Connection established with ID=${miccSignalr.id}`);
        dispatch('setMitelConnectionStatus', "Connected");
        commit(types.SET_MITEL_CALL_CODE, null);
        commit(types.SET_MITEL_CALLER_NAME, 'N/A');
        commit(types.SET_MITEL_CALLER_NUMBER, '');
        if (!employeeHub) {
            employeeHub = miccSignalr.createHubProxy('employeeHub');
        }
        employeeHub.invoke('addSelfMonitor');
        employeeHub.on('employeeConversationChanged', function onCallback(args) {
            var callCode = '';
            if (args[0].conversationState === "Offered") {
                var cc = rootState.callcodes;
                var thirdPartyCC = cc.third_party_call_codes;
                var customerCC = cc.customer_call_codes;
                var allCallCodes = thirdPartyCC.concat(customerCC);
                callCode = allCallCodes.filter((code) => {
                    return code.dnis.replace(/-/g, '') == args[0].dnis.replace(/-/g, '');
                })[0];
                var callerName = args[0].fromName;
                var callerNumber = args[0].fromAddress;

                commit(types.SET_MITEL_CALL_CODE, callCode);
                commit(types.SET_MITEL_CALLER_NAME, callerName);
                commit(types.SET_MITEL_CALLER_NUMBER, callerNumber);
            }
            else if (args[0].conversationState === "Abandoned" || args[0].conversationState === "Ended") {
                commit(types.SET_MITEL_CALL_CODE, null);
                commit(types.SET_MITEL_CALLER_NAME, 'N/A');
                commit(types.SET_MITEL_CALLER_NUMBER, '');
            }
        });

    }).fail(function () {
        console.error('Connection failed');
        dispatch('setMitelConnectionStatus', "Connection failure");
    });
    miccSignalr.error(function (error) {
        console.log('Connection SignalR error: ' + error);
    });
    miccSignalr.disconnected(function () {
        console.log('Disconnected. Attempting reconnect');
        dispatch('setMitelConnectionStatus', 'Disconnected. Attempting reconnect');
        setTimeout(function () {
            miccSignalr.start().done(function () {
                dispatch('setMitelConnectionStatus', "Connected");
            }).fail(function () {
                console.error('Connection failed');
                dispatch('setMitelConnectionStatus', "Connection failure");
            });
        }, 15000);
    });
    // miccSignalr.onConnectionSlow(processConnectionSlow);
    // miccSignalr.stateChanged(function() {
    //     console.warn('Connection SignalR state: ' + state);
    // });
    miccSignalr.reconnected(function () {
        console.warn('Connection SignalR reconnected');
        dispatch('setMitelConnectionStatus', "Connected");
    });
}

export const setMitelConnectionStatus = ({ commit }, status) => {
    commit(types.MITEL_CONNECTION_CHANGED, status);
};

export const checkCurrentCallStatus = ({ commit, rootState }) => {
    var accessToken = StorageManager.getJWT("MitelServiceJWT");
    mitelService.checkEmployeeConversations(accessToken).then((resp) => {
        if (resp._embedded.items.length > 0) {
            var dnis = resp._embedded.items[0].dnis;
            var callerName = resp._embedded.items[0].fromName;
            var callerNumber = resp._embedded.items[0].fromAddress;
            var cc = rootState.callcodes;
            var thirdPartyCC = cc.third_party_call_codes.length == 0 ? cc.call_codes : cc.third_party_call_codes;
            var customerCC = cc.customer_call_codes;
            var allCallCodes = thirdPartyCC.concat(customerCC);
            var callCode = allCallCodes.filter((code) => {
                return code.dnis.replace(/-/g, '') == dnis.replace(/-/g, '');
            })[0];

            commit(types.SET_MITEL_CALL_CODE, callCode);
            commit(types.SET_MITEL_CALLER_NAME, callerName);
            commit(types.SET_MITEL_CALLER_NUMBER, callerNumber);
        }
        else {
            commit(types.SET_MITEL_CALL_CODE, null);
            commit(types.SET_MITEL_CALLER_NAME, 'N/A');
            commit(types.SET_MITEL_CALLER_NUMBER, '');
        }
    });
}


// WEBPACK FOOTER //
// ./src/store/modules/dashboard/actions.js